export default class ResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    repeatPassword: string;
}
